module.exports = __webpack_public_path__ + "static/net-622434a3fa852fb28691370abda0a331.svg";